import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "all-content" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", { class: "sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header__top" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "sidebar__container" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "sidebar-header__text" }, "PROJECTUS")
    ])
  ])
], -1)
const _hoisted_4 = { class: "person-info sidebar__person-info" }
const _hoisted_5 = { class: "sidebar__container" }
const _hoisted_6 = { class: "person-info__main" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "person-info__titles" }
const _hoisted_9 = { class: "person-info__title" }
const _hoisted_10 = { class: "person-info__subtitle" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "person-info__more"
}, "...", -1)
const _hoisted_12 = { class: "sidebar__tasks" }
const _hoisted_13 = { class: "sidebar__container" }
const _hoisted_14 = { class: "tasks" }
const _hoisted_15 = { class: "tasks__item-num" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "tasks__item-text" }, "Completed Tasks", -1)
const _hoisted_17 = {
  class: "tasks__item",
  id: "open_tasks"
}
const _hoisted_18 = { class: "tasks__item-num" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "tasks__item-text" }, "Open Tasks", -1)
const _hoisted_20 = { class: "sidebar__navigation" }
const _hoisted_21 = { class: "sidebar__container" }
const _hoisted_22 = { class: "nav-container" }
const _hoisted_23 = { class: "sidebar-nav" }
const _hoisted_24 = { class: "sidebar-nav__item" }
const _hoisted_25 = { class: "sidebar-nav__item" }
const _hoisted_26 = { class: "sidebar-nav__item" }
const _hoisted_27 = ["data-after"]
const _hoisted_28 = { class: "main" }
const _hoisted_29 = { class: "header" }
const _hoisted_30 = { class: "main__container" }
const _hoisted_31 = { class: "header__top" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title__text" }, "Website Redesign"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "title__more"
  }, "...")
], -1)
const _hoisted_33 = { class: "socials" }
const _hoisted_34 = { class: "socials__photos" }
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "socials__share"
}, "Share", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "socials__chat"
}, "Chat", -1)
const _hoisted_38 = { class: "header__nav" }
const _hoisted_39 = {
  class: "nav",
  id: "nav"
}
const _hoisted_40 = { class: "nav__item" }
const _hoisted_41 = { class: "nav__item" }
const _hoisted_42 = { class: "nav__item" }
const _hoisted_43 = { class: "nav__item" }
const _hoisted_44 = { class: "nav__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: require('./assets/'+_ctx.avatar),
              alt: "Person photo",
              class: "person-info__photo"
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.userName), 1),
              _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.status), 1)
            ]),
            _hoisted_11
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", {
              class: "tasks__item",
              id: "completed_tasks",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeTasksCounter && _ctx.changeTasksCounter(...args))),
              onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.makeTasksActive && _ctx.makeTasksActive(...args))),
              onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.makeTasksNonActive && _ctx.makeTasksNonActive(...args)))
            }, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.completedTasks), 1),
              _hoisted_16
            ], 32),
            _createElementVNode("li", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.openTasks), 1),
              _hoisted_19
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("nav", _hoisted_22, [
            _createElementVNode("ul", _hoisted_23, [
              _createElementVNode("li", _hoisted_24, [
                _createElementVNode("a", {
                  href: "#",
                  class: "sidebar-nav__link sidebar-nav__link--active",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                }, "Menu")
              ]),
              _createElementVNode("li", _hoisted_25, [
                _createElementVNode("a", {
                  href: "#",
                  class: "sidebar-nav__link",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                }, "Home")
              ]),
              _createElementVNode("li", _hoisted_26, [
                _createElementVNode("a", {
                  href: "#",
                  class: "sidebar-nav__link",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                }, "My Tasks")
              ]),
              _createElementVNode("li", {
                class: "sidebar-nav__item sidebar-nav__item--notifications",
                id: "notifications",
                "data-after": _ctx.notifications
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: "sidebar-nav__link",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args))),
                  onGetIndex: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeNotifications && _ctx.changeNotifications(...args)))
                }, "Notifications", 32)
              ], 8, _hoisted_27)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_28, [
      _createElementVNode("header", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialImages, (item) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: item.id,
                    src: require('./assets/'+item.img),
                    alt: "socials photo",
                    class: "socials__photo"
                  }, null, 8, _hoisted_35))
                }), 128))
              ]),
              _hoisted_36,
              _hoisted_37
            ])
          ]),
          _createElementVNode("nav", _hoisted_38, [
            _createElementVNode("ul", _hoisted_39, [
              _createVNode(_component_router_link, { to: "/tasks" }, {
                default: _withCtx(() => [
                  _createElementVNode("li", _hoisted_40, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "nav__link",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                    }, "Tasks")
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("li", _hoisted_41, [
                _createElementVNode("a", {
                  href: "#",
                  class: "nav__link",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                }, "Kanban")
              ]),
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createElementVNode("li", _hoisted_42, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "nav__link nav__link--active",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                    }, "Activity")
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("li", _hoisted_43, [
                _createElementVNode("a", {
                  href: "#",
                  class: "nav__link",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                }, "Calendar")
              ]),
              _createElementVNode("li", _hoisted_44, [
                _createElementVNode("a", {
                  href: "#",
                  class: "nav__link",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.makeActive && _ctx.makeActive(...args)))
                }, "Files")
              ])
            ])
          ]),
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}